import React, { Component } from 'react'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import { Link } from 'react-router-dom'
import { InputError } from '@foodsby/nutrient'
import LoginForm from './LoginForm'
import { loginStart } from '../../redux/modules/user'
import { forgotPasswordRoute } from '../../routes/routes'

const LoginFormContainer = reduxForm({ form: 'login' })(LoginForm)

const LoginExtraButtons = () => (
  <div className="row center-xs">
    <div className="col-xs-6 center-xs">
      <Link tabIndex="5" to={forgotPasswordRoute.path}>
        Forgot Password?
      </Link>
    </div>
  </div>
)

class LoginPageForm extends Component {
  passwordVisibility() {
    let currentType = document.getElementById('loginPassword')
    currentType.type === 'password'
      ? (currentType.type = 'text')
      : (currentType.type = 'password')
  }

  render() {
    const { loginStart, error, path, submitting } = this.props
    return (
      <section>
        <LoginFormContainer
          toggleVisibility={this.passwordVisibility}
          submitting={submitting}
          onSubmit={creds => loginStart(creds, path)}
        />
        <InputError>{error ? error.message : ''}</InputError>
        <LoginExtraButtons />
      </section>
    )
  }
}

const mapStateToProps = state => {
  const { error, submitting } = state.user
  const { address = '' } = state.locationSearch

  return {
    address,
    submitting,
    error
  }
}

const mapDispatchToProps = {
  loginStart
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginPageForm)
